var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { api } from '../services/api-client';
let JvLiveView = class JvLiveView extends LitElement {
    constructor() {
        super(...arguments);
        this.cameraId = null;
        this._streamUrl = null;
        this._loading = true;
        this._error = '';
    }
    static { this.styles = css `
    :host {
      display: block;
      min-height: 100vh;
      background: #0f172a;
    }
    .topbar {
      background: rgba(15,23,42,.85);
      backdrop-filter: blur(12px);
      border-bottom: 1px solid rgba(255,255,255,.08);
    }
  `; }
    connectedCallback() {
        super.connectedCallback();
        void this._loadStream();
    }
    async _loadStream() {
        if (!this.cameraId)
            return;
        this._loading = true;
        this._error = '';
        try {
            const result = await api.get(`/api/cameras/${this.cameraId}/stream-url`);
            this._streamUrl = result;
        }
        catch (err) {
            const apiErr = err;
            this._error = apiErr?.message ?? apiErr?.error ?? 'Unable to load stream';
        }
        finally {
            this._loading = false;
        }
    }
    _handleBack() {
        this.dispatchEvent(new CustomEvent('back', { bubbles: true, composed: true }));
    }
    render() {
        return html `
      <header class="topbar w-full">
        <div class="max-w-content mx-auto px-5 h-14 flex items-center gap-4">
          <button @click=${this._handleBack} class="text-white/70 hover:text-white text-sm font-medium transition flex items-center gap-1.5">
            <svg viewBox="0 0 24 24" class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            Back
          </button>
          <span class="text-white/90 text-sm font-semibold truncate ml-2">Live View</span>
        </div>
      </header>

      <div class="max-w-content mx-auto px-5 py-8">
        ${this._loading ? html `
          <div class="flex items-center justify-center py-32">
            <div class="text-center">
              <div class="w-12 h-12 rounded-2xl bg-jv-primary/20 mx-auto mb-4 grid place-items-center">
                <div class="w-5 h-5 border-2 border-jv-primary border-t-transparent rounded-full animate-spin"></div>
              </div>
              <p class="text-white/60 text-sm">Loading camera stream…</p>
            </div>
          </div>
        ` : this._error ? html `
          <div class="flex items-center justify-center py-32">
            <div class="text-center max-w-sm">
              <div class="w-14 h-14 rounded-2xl bg-jv-danger/20 mx-auto mb-4 grid place-items-center">
                <svg viewBox="0 0 24 24" class="w-7 h-7 text-jv-danger" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
              <p class="text-white font-semibold">${this._error}</p>
              <button @click=${this._loadStream} class="mt-4 px-4 py-2 rounded-xl bg-jv-primary text-white text-sm font-semibold hover:bg-jv-primary-600 transition">Try again</button>
            </div>
          </div>
        ` : html `
          <div class="rounded-2xl overflow-hidden bg-black border border-white/10">
            ${this._streamUrl?.type === 'hls' ? html `
              <video class="w-full aspect-video" controls autoplay playsinline>
                <source src=${this._streamUrl.url} type="application/x-mpegURL" />
              </video>
            ` : html `
              <div class="w-full aspect-video bg-black grid place-items-center">
                <div class="text-center">
                  <div class="w-16 h-16 rounded-2xl bg-jv-primary/20 mx-auto mb-4 grid place-items-center">
                    <svg viewBox="0 0 24 24" class="w-8 h-8 text-jv-primary" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                  </div>
                  <p class="text-white/80 text-sm font-medium">WebRTC stream available at</p>
                  <p class="text-white/40 text-xs font-mono mt-1 break-all px-4">${this._streamUrl?.url ?? '—'}</p>
                  <p class="text-white/30 text-xs mt-3">Stream URL expires ${this._streamUrl?.expiresAt ? new Date(this._streamUrl.expiresAt).toLocaleTimeString() : '—'}</p>
                </div>
              </div>
            `}
          </div>
        `}
      </div>
    `;
    }
};
__decorate([
    property({ type: Object })
], JvLiveView.prototype, "profile", void 0);
__decorate([
    property({ type: String })
], JvLiveView.prototype, "cameraId", void 0);
__decorate([
    state()
], JvLiveView.prototype, "_streamUrl", void 0);
__decorate([
    state()
], JvLiveView.prototype, "_loading", void 0);
__decorate([
    state()
], JvLiveView.prototype, "_error", void 0);
JvLiveView = __decorate([
    customElement('jv-live-view')
], JvLiveView);
export { JvLiveView };
